/**
 * KNN Cart Count
 * Randomises the number in each [data-knn-cart-count] block on page load,
 * within the block's data-min / data-max range. The surrounding text is fixed.
 */
(() => {
  const init = () => {
    document.querySelectorAll('[data-knn-cart-count]').forEach((el) => {
      if (el.dataset.knnCartCountInit === 'true') return;
      el.dataset.knnCartCountInit = 'true';

      const target = el.querySelector('[data-knn-cart-count-number]');
      if (!target) return;

      const min = parseInt(el.dataset.min, 10) || 30;
      const max = Math.max(parseInt(el.dataset.max, 10) || 80, min);
      target.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
